import axios, { AxiosResponse } from 'axios';
import EnvWindow from '../../../utils/env';
import { IMainPage } from './mainPage.types';

const mainPageUrl = `${EnvWindow.REACT_APP_SUPPORT_API_URL}/MainPage`;

export async function getMainPage(): Promise<AxiosResponse<IMainPage>> {
  return await axios.get(mainPageUrl);
}

export async function updateMainPage(htmlContent: string): Promise<AxiosResponse> {
  return await axios.put(mainPageUrl, {
    htmlContent: htmlContent,
  });
}
